import { Component } from "solid-js";
import { A } from "@solidjs/router";
import logo from "../../../assets/brand/favicon.png";
import ThemeSwitcher from "./ThemeSwitcher.jsx";
import LanguageSwitcher from "./LanguageSwitcher.jsx";

const Header: Component = () => {
  return (
    <div class="navbar bg-base-200 shadow-sm border-b-2 border-base-300 sticky top-0 z-50">
      <div class="flex h-full w-full px-2 max-w-screen-2xl mx-auto p-0 gap-10 items-center">
        <A
          class="flex items-center gap-4 font-bold text-2xl whitespace-nowrap"
          href="/"
        >
          <img src={logo} alt="logo" width="32" height="32" />
          <p style="background: linear-gradient(to bottom, #3B90C2FF, #25AA8DFF); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
            Discord Integration
          </p>
        </A>
        <div class="flex gap-4items-center">
          <A
            class="link text-base-content/60 link-hover gap-2 flex items-center"
            href="https://docs.discord-integration.com"
          >
            <i class="fa-solid fa-book" />
            Documentation
          </A>
        </div>
        <div class="flex-1" />
        <div class="flex gap-2 items-center">
          <LanguageSwitcher />
          <ThemeSwitcher />
        </div>
      </div>
    </div>
  );
};

export default Header;
